export default {
  title: 'Candidate Status Management',
  menu: 'Candidate Status Management',
  label: {
    editCandidateStatus: 'Edit Candidate Status',
    addCandidateStatus: 'Add Candidate Status',
    status: 'Candidate Status',
    causeCN: 'Status Comment CN',
    causeEN: 'Status Comment EN',
    enabled: 'Enable',
    disabled: 'Disable',
    cnName: 'Candidate status CN name',
    enName: 'Candidate status EN name',
    statusEnableLabel: 'Status'
  },
  placeholder: {
    status: 'Please select candidate status',
    causeCN: 'Please input status comment CN',
    causeEN: 'Please input status comment EN',
    keywords: 'Keywords Search'
  },
  message: {
    deleteCandidateStatus: 'Are you sure you want to delete the {status}-{cause} ?',
    updateStatusSuccess: 'Update candidate status success',
    saveStatusSuccess: 'Save candidate status success'
  }
}
